import {List} from 'immutable';

/**
 * Filters a collection and returns a tuple of two separate collections.
 * The first element is the collection of all the elements for which the predicate returned true
 * The second element is the collection of all the elements for which the predicate returned false
 *
 * TODO Make this generic across immutable collections, or all collections?
 *
 * @param coll Collection to be partitioned
 * @param pred Predicate to use for filtering
 */
export default function partitionBy<T>(coll: List<T>, pred: (t: T) => boolean): [List<T>, List<T>] {
  const passed = coll.filter(pred);
  const failed = coll.filterNot(pred);
  return [passed, failed];
}
